import lokult_logo_white from "../assets/lokult_logo_white.svg";

const Footer = () => {
  return (
    <div className="bg-base-200  border-t border-base-content/20 flex justify-center">
      <footer className="footer max-w-7xl  text-base-content p-10 relative  grid grid-cols-1 md:grid-cols-4 gap-4">
        <aside>
          <img
            src={lokult_logo_white}
            alt="Lokult logo"
            className="border-2 rounded-2xl"
          />
          <p>För den lokala musiken</p>
        </aside>
        <nav>
          <h6 className="footer-title">ATT UPPTÄCKA</h6>
          <a href="/discover" className="link link-hover">
            Upptäck musik
          </a>
          <a href="/events" className="link link-hover">
            Events
          </a>
          <a href="/news" className="link link-hover">
            Nyheter
          </a>
          <a href="/blogs" className="link link-hover">
            Bloggar
          </a>
          <a href="/search" className="link link-hover">
            Sök
          </a>
        </nav>
        <nav>
          <h6 className="footer-title">LOKULT</h6>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.instagram.com/lokult.se/"
            className="link link-hover"
          >
            Instagram
          </a>
          <a href="/about" className="link link-hover">
            Om Lokult
          </a>
          <a href="/lokult-news" className="link link-hover">
            Lokultnyheter
          </a>
          <a href="/contact" className="link link-hover">
            Kontakt
          </a>
          <a href="/partnership" className="link link-hover">
            Annonsinfo
          </a>
        </nav>
        <nav>
          <h6 className="footer-title">TRÅKIGA SEKTORN</h6>
          <a href="/terms" className="link link-hover">
            Allmänna villkor
          </a>
          <a href="/gdpr" className="link link-hover">
            GDPR
          </a>
          <a href="/" className="link link-hover">
            Cookies
          </a>
        </nav>
        <p className="absolute bottom-0 p-2 right-0 opacity-80">
          Skapad av ESH
        </p>
      </footer>
    </div>
  );
};

export default Footer;
